<template>
  <div class="container-box">
    <!-- 表单内容 -->
    <el-form :inline="true" :model="qualityData">
      <div class="form-container">
        <!-- 反馈单号 -->
        <el-form-item :label="$t('zlfk.fkdh') + ':'">
          <el-input
            v-if="!isLookOperate"
            disabled
            v-model="qualityData.feedbackFormId"
          ></el-input>
          <b v-else>{{ qualityData.feedbackFormId }}</b>
        </el-form-item>
      </div>
    </el-form>
    <!-- 存在问题 -->
    <div class="hearder-title">
      <div class="flex_between">
        <img src="@/assets/image/faultInfo.png" alt="" />
        {{ $t("zlfk.czwt") }}
      </div>
    </div>
    <!-- 表格搜索条件表单 -->
    <div class="filter-container" v-if="isLookOperate">
      <el-form :inline="true" :model="queryParams" :label-width="labelWidth">
        <!-- 销售订单号 -->
        <el-form-item :label="$t('zlfk.wtbh') + ':'">
          <el-input
            v-model="queryParams.questionNum"
            :placeholder="$t('home.placeholder') + ':'"
          ></el-input>
        </el-form-item>
        <!-- 故障描述 -->
        <el-form-item :label="$t('restockInfo.gzxxms') + ':'">
          <el-input
            v-model="queryParams.questionContent"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item :label="$t('climant.status') + ':'">
          <el-select filterable clearable v-model="queryParams.status">
            <el-option :label="$t('zlfk.bbh')" :value="3"></el-option>
            <el-option :label="$t('zlfk.clz')" :value="1"></el-option>
            <el-option :label="$t('zlfk.dqr')" :value="2"></el-option>
            <el-option :label="$t('home.closed')" :value="4"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div></div>
        <div>
          <el-button class="primary-btn" type="primary" @click="doSearch">
            <i class="subSearch-icon"></i>
            {{ $t("home.query") }}
          </el-button>
          <el-button class="primary-btn" plain @click="handleResetQuery">
            <i class="el-icon-refresh-right"></i>
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <div class="table-btn">
        <!-- 新增问题 -->
        <el-button
          v-if="!isLookOperate"
          class="primary-btn"
          type="primary"
          size="small"
          @click="handleAddOrEdit($t('zlfk.xzwt'))"
          icon="el-icon-plus"
          >{{ $t("zlfk.xzwt") }}</el-button
        >
      </div>
      <el-table
        ref="tableRef"
        stripe
        border
        highlight-current-row
        :data="tableData"
      >
        <!-- 序号 -->
        <el-table-column
          :label="$t('cart.xh')"
          width="60px"
          align="center"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            {{ getColumnIndex(scope.$index) }}
          </template>
        </el-table-column>
        <!-- 问题序号 -->
        <el-table-column
          property="questionNum"
          :label="$t('zlfk.wtbh')"
          min-width="160px"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="isLookOperate"
              class="lineTheme"
              @click="handleLook(scope.row)"
            >
              {{ scope.row.questionNum }}
            </div>
            <div v-else>{{ scope.row.questionNum }}</div>
            <!-- <div class="questionNum">
              <img
                v-if="scope.row.importantType === 1"
                class="title-icon"
                src="@/assets/img/import-icon.svg"
              />
              {{ scope.row.questionNum }}
            </div> -->
          </template>
        </el-table-column>
        <el-table-column
          property="importantType"
          :label="$t('zlfk.sfzdwt')"
          width="110px"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.importantType == 1" style="color: #f56c6c">{{
              $t("seek.yes")
            }}</span>
            <span v-if="scope.row.importantType == 0">{{ $t("seek.no") }}</span>
          </template>
        </el-table-column>
        <!-- 销售订单号 -->
        <el-table-column
          property="orderNum"
          :label="$t('zlfk.xsddh')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 车型 -->
        <el-table-column
          property="carModel"
          :label="$t('home.carType')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 订单车辆数量 -->
        <el-table-column
          property="carTotal"
          :label="$t('zlfk.ddsl')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 故障配件数量 -->
        <el-table-column
          property="faultTotal"
          :label="$t('zlfk.gzpjsl')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 故障率 -->
        <el-table-column
          property="badTax"
          :label="$t('zlfk.gzl')"
          min-width="90px"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{ (scope.row.badTax * 100).toFixed(2) + "%" }}
          </template>
        </el-table-column>
        <!-- 零部件类别 -->
        <el-table-column
          property="componentType"
          :label="$t('restock.componentType')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{ getComponentCategoryLabel(scope.row.componentType) }}
          </template>
        </el-table-column>
        <!-- 故障描述 -->
        <el-table-column
          :label="$t('restockInfo.gzxxms')"
          min-width="200px"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <!--            {{ getFaultDescription(scope.row) }}-->
            {{ scope.row.questionContent }}
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          v-if="isLookOperate"
          :label="$t('climant.status')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <div class="statusDetail" v-if="scope.row.status === 0">
              <img src="@/assets/image/draft.png" alt="" />
              <span>{{ $t("climant.noSubmit") }}</span>
            </div>
            <div class="statusDetail" v-if="scope.row.status === 1">
              <img src="@/assets/image/submitted.png" alt="" />
              <span>{{ $t("zlfk.clz") }}</span>
            </div>
            <div class="statusDetail" v-if="scope.row.status === 2">
              <img src="@/assets/image/confirmed.png" alt="" />
              <span>{{ $t("zlfk.dqr") }}</span>
            </div>
            <div class="statusDetail" v-if="scope.row.status === 3">
              <img src="@/assets/image/canceled.png" alt="" />
              <span>{{ $t("zlfk.bbh") }}</span>
            </div>
            <div class="statusDetail" v-if="scope.row.status === 4">
              <img src="@/assets/image/completed.png" alt="" />
              <span>{{ $t("home.closed") }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- 更新时间 -->
        <el-table-column
          v-if="isLookOperate"
          property="updateTime"
          :label="$t('zlfk.gxsj')"
          min-width="180px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="$t('cart.operate')"
          :width="
            isLookOperate
              ? '105px'
              : { ru: 205, es: 140, vi: 140 }[$i18n.locale] || '115'
          "
          align="center"
          fixed="right"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button
              v-if="isLookOperate"
              type="text"
              @click="handleLook(scope.row)"
              >{{
                scope.row.status === 2 || scope.row.status === 3
                  ? $t("restockInfo.process")
                  : $t("operate.view")
              }}</el-button
            >
            <!-- 编辑 -->
            <el-button
              v-if="!isLookOperate"
              type="text"
              @click="handleAddOrEdit($t('zlfk.bjwt'), scope.row)"
              >{{ $t("home.edit") }}</el-button
            >
            <!-- 删除 -->
            <el-button
              v-if="!isLookOperate"
              type="text"
              @click="handleDelete(scope.row)"
              >{{ $t("cart.delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <pagination
          v-if="total > 0"
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
    <!--    <div class="flex_default_center" style="padding-bottom: 20px">-->
    <!--      <el-button size="small" class="primary-btn lang-but" plain type="primary" @click="back">-->
    <!--        {{ $t("seek.cancel") }}-->
    <!--      </el-button>-->
    <!--    </div>-->
    <problem-dialog ref="problemDialog" @success="getDetail" />
  </div>
</template>

<script>
import listCurd from "@/mixins/listCurd";
import { getStorage, setStorageNew } from "@/util/localStor";
import { questionListApi, problemDeleteApi } from "@/api/qualityKD";
import ProblemDialog from "./components/problemDialog.vue";
import faultData from "@/mixins/faultData";

export default {
  components: {
    ProblemDialog,
  },
  mixins: [listCurd, faultData],
  data() {
    return {
      pageName: {
        add: "zlfk.xzfkd",
        edit: "zlfk.bjfkd",
        look: "zlfk.ckfkd",
      }, // 页面标题
      qualityData: {}, // 质量反馈数据
      isLookOperate: false,
      queryParams: {
        feedbackFormId: "",
        status: this.$route?.query.status
          ? Number(this.$route?.query.status)
          : "",
      }, // 查询参数
      listMethod: questionListApi, // 获取表格数据api
      type: "kdFeedbackDetail",
    };
  },

  created() {
    // 页面标题
    this.$route.meta.title = this.pageName[this.$route.query.operate];
    this.isLookOperate = this.$route.query.operate === "look" ? true : false;
    sessionStorage.removeItem("goBackPath");
    // 质量反馈详情数据
    this.qualityData = getStorage("qualityData");
    // 获取表格数据
    if (this.qualityData.feedbackFormId) {
      this.getList();
    }
    // 零部件类别
    this.getTypeList();
  },

  computed: {
    // 计算表单label宽度
    labelWidth() {
      const widthMap = {
        zh: "95px",
        ru: "280px",
        en: "235px",
        vi: "160px",
        es: "255px",
      };
      return widthMap[this.$i18n.locale] || "130px";
    },
  },
  methods: {
    //获取零部件类别
    getComponentCategoryLabel(code) {
      if (this.componentCategoryList && this.componentCategoryList.length > 0) {
        const item = this.componentCategoryList.find((i) => i.code === code);
        if (item && this.componentCategoryName) {
          return (
            item[this.componentCategoryName.get(this.$i18n.locale)] ||
            item.nameZh
          );
        }
      }
      return code;
    },

    // 查询参数
    getParams() {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) };
      params.feedbackFormId = this.qualityData.feedbackFormId;
      return {
        data: {
          ...params,
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      };
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // (新增 | 编辑)问题
    handleAddOrEdit(
      title,
      data = { feedbackFormId: this.qualityData.feedbackFormId }
    ) {
      this.$refs.problemDialog.init(title, data);
    },
    // 查看问题
    handleLook(data) {
      setStorageNew("problemData", data);
      this.getSetItem();
      console.log(this.$route.fullPath);
      sessionStorage.setItem("goBackPath", this.$route.fullPath);
      this.$router.push("/qualityNew/qualityKD/problemDetail");
    },
    // 获取反馈单详情
    getDetail(data) {
      this.qualityData.feedbackFormId = this.qualityData.feedbackFormId || data;
      setStorageNew("qualityData", this.qualityData);
      this.getList();
    },
    // 获取故障描述
    getFaultDescription(row) {
      let qdf = {};
      try {
        if (
          row.questionDescriptionAndFiles &&
          typeof row.questionDescriptionAndFiles === "string"
        ) {
          qdf = JSON.parse(row.questionDescriptionAndFiles);
        } else if (
          row.questionDescriptionAndFiles &&
          typeof row.questionDescriptionAndFiles === "object"
        ) {
          qdf = row.questionDescriptionAndFiles;
        }
      } catch (e) {
        console.error("Failed to parse questionDescriptionAndFiles", e);
      }
      return qdf.faultDescription || row.faultDescription || "";
    },
    // 删除问题
    async handleDelete(row) {
      await this.$confirm(
        `${this.$t("zlfk.qrsc")}？`,
        this.$t("cart.delete"),
        {
          confirmButtonText: this.$t("seek.confirm"),
          cancelButtonText: this.$t("seek.cancel"),
          type: "warning",
        }
      );
      const res = await problemDeleteApi({
        data: {
          questionId: row.questionId,
        },
      });
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("message.czcg"));
        this.getList();
      } else {
        this.$DonMessage.error(res.message);
      }
    },
  },
};
</script>
